<h4 mat-dialog-title>Редактирование контакта</h4>
<app-close-button [formGroup]="personForm" [dialogRef]="dialogRef"/>
@if (loading()) {
    <app-loader [isLoading]="loading()"></app-loader>
} @else {
    <mat-dialog-content>
        <form class="flex-column" [formGroup]="personForm" (ngSubmit)="onSubmit()">

            <mat-form-field appearance="fill">
                <mat-label>Имя</mat-label>
                <input matInput formControlName="firstName" />
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>Фамилия</mat-label>
                <input matInput formControlName="lastName" />
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>Телефон</mat-label>
                <input matInput formControlName="phone" />
            </mat-form-field>

            <button mat-flat-button color="primary" type="submit" [disabled]="!personForm.valid">Сохранить</button>
        </form>
    </mat-dialog-content>
}
